var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.57,24.43c1.48,1.48,1.48,3.88,0,5.37l-20.2,20.2,20.2,20.2c1.48,1.48,1.48,3.89,0,5.37-1.48,1.48-3.89,1.48-5.37,0l-20.2-20.2-20.2,20.2c-1.48,1.48-3.89,1.48-5.37,0s-1.48-3.89,0-5.37l20.2-20.2-20.2-20.2c-1.48-1.48-1.48-3.88,0-5.37,1.48-1.48,3.89-1.48,5.37,0l20.2,20.2,20.2-20.2c1.48-1.48,3.89-1.48,5.37,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeClose);
export default __webpack_public_path__ + "static/media/acae_close.32d33eb5.svg";
export { ForwardRef as ReactComponent };